import React from 'react'
import { StyledLabel } from '../../assets/styledComponents/Global'
import styled from 'styled-components'
import StyledButton from '../../app/components/styledComponents/StyledButton';

const ThinkTimer = ({ thinkCountdown, skipPreparation }) => {
    const formatTime = (s) => {
        const m = String(Math.floor(s / 60)).padStart(2, '0');
        const sec = String(s % 60).padStart(2, '0');
        return `${m}:${sec}`;
    };
    return (
        <div
            className='d-flex align-items-center justify-content-center flex-column'
            style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 1000, }}
        >
            <StyledLabel size="32px" fill="white" font="Fredoka" weight="500" color='white' >
                {formatTime(thinkCountdown)}
            </StyledLabel>
            <ThinkTimeLabel>
                Preparation Time
            </ThinkTimeLabel>

            <StyledButton variant='white' onClick={skipPreparation} style={{ marginTop: 10 }}  >
                Skip{' '}
            </StyledButton>
        </div>
    )
}

export default ThinkTimer


const ThinkTimeLabel = styled.div`
width: 150px;
height: 33px;
angle: 0 deg;
opacity: 1;
gap: 10px;
border-radius: 22px;
padding-top: 7px;
padding-right: 10px;
padding-bottom: 7px;
padding-left: 10px;
background: #FFFFFF80;
color:white;
display:flezx;
align-items:center;
justify-content:center;
backdrop-filter: blur(12.079999923706055px);

`